import React from "react";
import Typography from "@mui/material/Typography";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { uploadIconStyles } from "./styles";
import { UTF8_ENCODING_REQUIREMENT, DRAG_DROP_INSTRUCTION } from "./constants";

interface DefaultContentProps {
  formattedExtensions: string;
  maxSize?: number;
}

/**
 * Default content displayed in the FileInput when no custom content is provided
 */
const DefaultContent: React.FC<DefaultContentProps> = ({
  formattedExtensions,
  maxSize,
}) => {
  return (
    <>
      <CloudUploadIcon style={uploadIconStyles} />
      <Typography
        variant="body1"
        textAlign="center"
        color="textSecondary"
        gutterBottom
      >
        Accepted formats: {formattedExtensions} ({UTF8_ENCODING_REQUIREMENT})
      </Typography>
      <Typography variant="body2" textAlign="center" color="textSecondary">
        {DRAG_DROP_INSTRUCTION}
        {maxSize && ` (Max size: ${Math.round(maxSize / (1024 * 1024))}MB)`}
      </Typography>
    </>
  );
};

export default DefaultContent;
